<!--
  This is the property of FRBNY and cannot be shared or disclosed without consent and strictly prohibited.
  
  Story: FR-TSM-003 (View Tour Calendar)
  Generated by: AI-DLC Workflow
  
  Root application component.
-->
<template>
  <div id="app">
    <AppHeader />
    <main class="app-main">
      <RouterView />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-main {
  flex: 1;
}
</style>
